import React from "react";

export const DisputesIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-6 h-6 text-gray-100",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}
            {...props}>
            <path d="M12 2L5 5V11C5 16 8.5 20.5 12 22C15.5 20.5 19 16 19 11V5L12 2Z"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round" />

            <line x1="12" y1="8" x2="12" y2="13"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round" />

            <circle cx="12" cy="16" r="1" stroke="currentColor" />
        </svg>
    );
};